<template>
	<div style="text-align: center">
		<div v-if="imgList.length > 0">
			<img style="width: 1000px" v-for="img in imgList" :src="img">
		</div>
		<el-empty v-else description="暂无数据"></el-empty>
	</div>
</template>

<script>
	import { getLicenseImg } from '../../api/home.js';
	
	export default {
		name: "license",
		data() {
			return {
				imgList: []
			}
		},
		created() {
			getLicenseImg().then(res => {
				if (res && res.code == 0 && res.data) {
					if (res.data.length > 0 && res.data[0].url) {
						this.imgList = res.data[0].url.split(',');
					}
				}
				else {
					this.$message.error(res && res.msg ? res.msg : '暂未查询到经营资质信息!');
				}
			});
		}
	}
</script>

<style scoped>

</style>